import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {createFieldMap} from '../../common/util/Util';
import {TableControl} from '../../common/models/TableControl';
import {EntityTable} from '../../common/types/entity-table.enum';

export class OtherRequestBuilder {

  // By Table Control:
  // Act as Default base method to get PagedRequestDTO
  // Filtering on Single || Multiple Columns Applied on
  // Component Level

  public static getTblRulesEngineMetadataPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblRulesEngineMetadata;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  public static getIntegrationTblMessagesErrorPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblMessage;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;
    pagedRequestDTO.fieldMap = {};

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    return pagedRequestDTO;
  }

  public static getTblUserPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblUser;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  public static getTblApplicationPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblApplication;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  public static getTblBrokerPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblBroker;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection;

    // Note: 'filterField' to control table filter data by 'filterValue'
    if (tableControl.filterField) {
      pagedRequestDTO.fieldMap = createFieldMap(
        tableControl.filterField,
        tableControl.filterValue
      );
    }
    else {
      pagedRequestDTO.fieldMap = null;
    }
    return pagedRequestDTO;
  }

  public static getTableControls(length = 100,
                                 pageSize = 10,
                                 pageNumber = 0,
                                 pageSizeOptions = [5, 10, 25, 100]) {
    return {
      length,
      pageSize,
      pageNumber,
      pageSizeOptions
    };
  }
}
